module.exports = __webpack_public_path__ + "img/marker_six_green1.737f95e8.png";